import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private readonly VERSION_KEY = 'app_version';
  private readonly RESOURCE_PATTERN =
    /assets\.cache\.static\/.*\/(resources|error-messages)\.json$/;

  constructor() {}

  checkVersionAndClean(): void {
    const currentVersion = environment.APP_VERSION;
    const storedVersion = localStorage.getItem(this.VERSION_KEY);

    if (storedVersion === currentVersion) {
      return;
    }

    // usunięcie danych związanych z resources
    this.#clearResourcesCache();
    // zapis nowej wersji w localStorage
    localStorage.setItem(this.VERSION_KEY, currentVersion);
  }

  #clearResourcesCache(): void {
    Object.keys(localStorage).forEach((key) => {
      if (this.RESOURCE_PATTERN.test(key)) {
        localStorage.removeItem(key);
      }
    });
  }
}
